import { gql } from '@apollo/client';

export const CREATE_AUDIT_SESSION = gql`
  mutation CreateAuditSession($input: CreateAuditSessionInput!) {
    createAuditSession(input: $input) {
      id
      name
      status
      createdBy
      createdAt
      completedAt
      itemsCount
      completedCount
      skippedCount
      pendingCount
    }
  }
`;
